import React from 'react';
import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';

/** Format a number as USD currency */
export const formatCurrency = (amount: number | null | undefined): string => {
  if (amount === null || amount === undefined) return 'No limit';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount);
};

/** Get threshold display text from min/max amounts */
export const getApprovalThresholdText = (
  minAmount: number | null | undefined,
  maxAmount: number | null | undefined
): string => {
  if (minAmount === null || minAmount === undefined) {
    if (maxAmount === null || maxAmount === undefined) return 'Any amount';
    return `Up to ${formatCurrency(maxAmount)}`;
  }
  if (maxAmount === null || maxAmount === undefined) return `${formatCurrency(minAmount)} and above`;
  return `${formatCurrency(minAmount)} - ${formatCurrency(maxAmount)}`;
};

interface ThresholdTemplateProps {
  minAmount?: number | null;
  maxAmount?: number | null;
}

/**
 * Displays approval threshold range.
 */
export const ThresholdTemplate: React.FC<ThresholdTemplateProps> = ({ minAmount, maxAmount }) => (
  <span>{getApprovalThresholdText(minAmount, maxAmount)}</span>
);

/** Syncfusion grid template wrapper */
export const thresholdTemplate = (props: WriteoffApprovalView) => (
  <ThresholdTemplate minAmount={props.minAmount} maxAmount={props.maxAmount} />
);

export default ThresholdTemplate;
